/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Authentication API
 * This Authentification API for Kazaar
 * OpenAPI spec version: 1.1.11
 */

/**
 * Preferred language of the User
 * @nullable
 */
export type UserEntityPreferredLanguage = typeof UserEntityPreferredLanguage[keyof typeof UserEntityPreferredLanguage] | null;


export const UserEntityPreferredLanguage = {
  fr: 'fr',
  en: 'en',
  de: 'de',
  it: 'it',
  es: 'es',
  gr: 'gr',
  pl: 'pl',
  hr: 'hr',
  sl: 'sl',
  jp: 'jp',
} as const;
